class Environment {
	static getAppDomain() {
		return "app." + Environment.getDomain();
	}
	
	static getCdnPath() {
		return "cdn." + Environment.getDomain();
	}
	
	// Parent domain shared by every nPerf subdomain: www.qa001.nperf.com -> qa001.nperf.com
	static getDomain() {
		return window.location.hostname.replace(/^www\./, '');
	}
	
	// YUFFIE_FORCE_PROD: pre-prod environments lack map data, so they read the production Yuffie.
	// YUFFIE_WS overrides everything for local dev, where Yuffie is not exposed under ws.<domain>.
	static getYuffieWs() {
		if (process.env.YUFFIE_WS) {
			return process.env.YUFFIE_WS;
		}
		
		const domain = process.env.YUFFIE_FORCE_PROD === 'true' ? 'nperf.com' : Environment.getDomain();
		return "https://ws." + domain + "/yuffie/v1";
	}
}

module.exports = Environment;
